export default "__VITE_ASSET__BNHJNDKl__"